import axios from 'axios';
import { Base_URL } from "../url";

export const fetchAssetCategory = async () => {
  const url = `${Base_URL}/AssetCategory/GetAllAssetCategories`;
  try {
    const response = await axios.get(url);
    console.log(response.data, 'response on body type')
    return response.data;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

export const fetchAssetCondition = async () => {
  const url = `${Base_URL}/AssetCondition/GetAllAssetConditions`;
  try {
    const response = await axios.get(url);
    console.log(response.data, 'response on body type')
    return response.data;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

export const fetchAssetType = async () => {
  const url = `${Base_URL}/AssetType/GetAllAssetTypes`;
  try {
    const response = await axios.get(url);
    console.log(response.data, 'response on body type')
    return response.data;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

export const fetchAssetDepMethod = async () => {
  const url = `${Base_URL}/DepreciationMethod/GetAllDepreciationMethods`;
  try {
    const response = await axios.get(url);
    console.log(response.data, 'response on body type')
    return response.data;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

export const fetchAssetMasters = async () => {
  try {
    const response = await axios.get(`${Base_URL}/AssetsList/GetAllAssets`);
    // console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching budget masters!";
  }
};

export const fetchAssignedAsset = async () => {
  try {
    const response = await axios.get(`${Base_URL}/AssignAssets/GetAssignedAssets`);
    // console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching budget masters!";
  }
};

export const fetchServiceAsset = async () => {
  try {
    const response = await axios.get(`${Base_URL}/AssetService/GetAllServices`);
    // console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching budget masters!";
  }
};

export const fetchAssetStatus = async () => {
  try {
    const response = await axios.get(`${Base_URL}/AssetStatus/GetStatusList`);
    // console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching budget masters!";
  }
};